"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.A = exports.ACSS = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _typography = _interopRequireDefault(require("./typography.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ACSS = (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-decoration: none;\n  &,\n  &:visited,\n  &:active {\n    color: ", ";\n  }\n  &:hover {\n    color: ", ";\n    text-decoration: none;\n    cursor: pointer;\n  }\n"])), function (props) {
  if (props.theme.colors[props.color] != null) {
    return props.theme.colors[props.color][500];
  }

  return props.theme.colors.brand[500];
}, function (props) {
  if (props.theme.colors[props.color] != null) {
    return props.theme.colors[props.color][300];
  }

  return props.theme.colors.brand[100];
});
exports.ACSS = ACSS;

var A = _styledComponents.default.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), ACSS, _typography.default);

exports.A = A;
var _default = A;
exports.default = _default;